import { createSelector } from 'reselect'

export const getPackages = createSelector(
  state => state && state.ads && state.ads.add && state.ads.add.packages && Array.isArray(state.ads.add.packages)
    ? state.ads.add.packages : [],
  packages => packages
)
